<template>
  <tr class="table-filter" :class="{'table-filter--active': filterActive}">
    <th v-for="(col, $index) in columns" :key="col.key">
      <div v-if="col.key !== null" class="filter-input-group">
        <input v-model="filterValues[col.key]"
               type="search"
               class="filter-input"
               :class="{'filter-input--active': filterFieldActive(col.key)}"
               @input="filterChanged"
        />
      </div>
      <button
        v-else-if="$index === 0 && filterActive"
        class="asd-btn-delete asd-btn-single-icon"
        @click="cancelFilter()"
      >
        <i class="fas fa-times"></i>
      </button>
    </th>
  </tr>
</template>

<script>
import _ from 'lodash'

const transformAdditionalCol = col => {
    if (col === null) return { label: null, key: null }
    return col
}

export default {
    name: 'TableFilter',
    props: {
        leadingCols: {
            type: Array,
            required: false,
            default: _ => [],
        },
        trailingCols: {
            type: Array,
            required: false,
            default: _ => [],
        },
        cols: {
            type: Array,
            required: true,
            default: _ => [],
        },
        userFilter: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
    },
    data() {
        return {
            filterValues: {},
        }
    },
    computed: {
        columns() {
            return [
                ..._.map(this.leadingCols, transformAdditionalCol),
                ..._.map(this.cols, key => {
                    const pt = this.$store.getters.propertyTypeByKey(key)
                    return {
                        label: pt.name,
                        key,
                    }
                }),
                ..._.map(this.trailingCols, transformAdditionalCol),
            ]
        },
        columnsPropertyValues() {
            return _.map(this.cols, c => {
                return this.$store.getters.propertyTypeByKey(c)
            })
        },
        filterActive() {
            return !!_.size(this.filterValues) > 0
        },
        debouncedChange() {
            return _.debounce(() => {
                this.$emit('filter-changed', this.filterValues)
            }, 700, { 'leading': false })
        },
    },
    watch: {
        userFilter(n, o) {
            this.filterValues = _.clone(n)
        },
    },
    methods: {
        filterChanged() {
            this.filterValues = _.pickBy(this.filterValues, f => {
                return _.size(f) > 0
            })
            this.debouncedChange()
        },
        cancelFilter() {
            this.filterValues = {}
            this.filterChanged()
        },
        filterFieldActive(key) {
            return !!_.get(this.filterValues, key, false)
        },
    },
}
</script>
